export default "__VITE_ASSET__795052ec__"